<template>
  <div>
    <a
      v-for="post in posts"
      :key="post.id"
      :href="post.postUrl"
      class="article-member"
    >
      <div class="info">
        <div class="d-flex iconTitle">
          <i class="type Artículos"></i>
          <div>
            <div class="kicker">
              {{ post.header }}
              <span class="date">{{ formatDate(post.create) }}</span>
            </div>
            <h3 class="title" v-html="post.title"></h3>
          </div>
        </div>
      </div>
    </a>
    <div class="title-section defaultSect" v-if="nextPageEnabled">
      <h3 class="heading-title-sect text-center">
        <a @click="nextPage"><span>VER MÁS</span></a>
      </h3>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
moment.locale("es-co");
export default {
  props: {
    total: Number,
    id: Number,
    skip: Number,
  },
  created: function () {
    this.take = 10;
    this.internalSkip = this.skip;
  },
  data() {
    return {
      posts: [],
      loading: false,
    };
  },
  computed: {
    nextPageEnabled() {
      return this.total > this.internalSkip && !this.loading;
    },
  },
  methods: {
    formatDate(dat) {
      return moment(dat).format("MMM D, YYYY");
    },
    nextPage() {
      this.loading = true;
      const _self = this;
      axios
        .get("/api/pager/posts-by-editorial-staff-member", {
          params: {
            id: this.id,
            take: this.take,
            skip: this.internalSkip,
          },
        })
        .then(function (d) {
          _self.loading = false;
          _self.posts = _self.posts.concat(d.data);
          _self.internalSkip += _self.take;
        });
    },
  },
};
</script>